var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activity" }, [
    !_vm.eventShow
      ? _c(
          "div",
          { staticClass: "activity-menu" },
          _vm._l(_vm.activetyList, function (item, i) {
            return _c(
              "div",
              {
                key: i,
                staticClass: "menu-item active",
                class: { active: _vm.curIndex === i },
                on: {
                  click: function ($event) {
                    _vm.curIndex = i
                    _vm.eventShow = true
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.title) + " ")]
            )
          }),
          0
        )
      : _vm._e(),
    _vm.activetyList.length > 0 && _vm.eventShow
      ? _c("div", { staticClass: "activity-content" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.activetyList[_vm.curIndex].title)),
          ]),
          _c("div", {
            staticClass: "instructions",
            domProps: {
              innerHTML: _vm._s(
                _vm.activetyList[_vm.curIndex].content.replace(
                  "/Upload/",
                  _vm.config.imgbaseURL + "/Upload/"
                )
              ),
            },
          }),
        ])
      : _vm._e(),
    _vm.eventShow
      ? _c(
          "div",
          {
            staticClass: "submit-button",
            on: {
              click: function ($event) {
                _vm.eventShow = false
              },
            },
          },
          [_vm._v("返回活动列表")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }